import { permissionLevels } from "@/constants";

export default {
  setAuthentication(ctx, payload) {
    // console.log("set authentication");
    // console.log("userId: ", payload.userId);
    if (payload.userId) {
      ctx.commit("SET_USER_ID", payload.userId);
    }
    ctx.commit("SET_TOKEN", payload.accessToken);
  },
  setUserName(ctx, payload) {
    ctx.commit("SET_USER_NAME", payload);
  },
  setPermissions(ctx, payload) {
    ctx.commit("SET_IS_SUPER_ADMIN", payload.superAdmin);
    ctx.commit("SET_IS_TREASURER_ADD_CLIENT", payload.isTreasurerAddClient);
    ctx.commit("SET_USER_ID", payload.userId);

    const treasurerAccounts = filterTreasurerAccounts(
      payload.accountPermissions,
      ctx.state
    );
    ctx.commit("SET_IS_TREASURER", treasurerAccounts.length > 0);
    ctx.commit("SET_TREASURER_ACCOUNTS", treasurerAccounts);
    ctx.commit(
      "SET_CONSULTANT_FUNDRAISER_ACCOUNTS",
      filterConsultantFundraiserAccounts(payload.accountPermissions)
    );
    ctx.commit("SET_AUTHENTICATED", true);
  },
  setIsLoginFromOldUI(ctx, payload) {
    ctx.commit("SET_IS_LOGIN_FROM_OLD_UI", payload);
  },
  setRedirectUrl(ctx, payload) {
    ctx.commit("SET_REDIRECT_URL", payload);
  },
  setUserDateOfBirth(ctx, payload) {
    ctx.commit("SET_USER_DATE_OF_BIRTH", payload);
  },
  setUserData(ctx, payload) {
    ctx.commit("SET_USER_DATA", payload);
  },
  logout(ctx) {
    resetState(ctx);
    ctx.commit("REMOVE_REDIRECT_URL");
    ctx.dispatch("app/setMainSidebarOpenState", true, { root: true });
    ctx.dispatch("app/setSecondSidebarOpenState", true, { root: true });
    ctx.dispatch("app/setAccountSubmenuOpenState", true, { root: true });
    ctx.dispatch("app/setEventSubmenuOpenState", false, { root: true });
    ctx.dispatch("app/setLoggedOut", true, { root: true });
  },
  resetState(ctx) {
    resetState(ctx);
  },
  // setAuthenticated(ctx, payload) {
  // 	ctx.commit("SET_AUTHENTICATED", payload);
  // },
  // setUser(ctx, payload) {
  // 	ctx.commit("SET_USER_ID", payload);
  // },
  // setToken(ctx, payload) {
  // 	ctx.commit("SET_TOKEN", payload);
  // },
  // setTokenExpiration(ctx, payload) {
  // 	ctx.commit("SET_TOKEN_EXPIRATION", payload);
  // },
  // setIsSuperAdmin(ctx, payload) {
  // 	ctx.commit("SET_IS_SUPER_ADMIN", payload);
  // },
  // setIsTreasurer(ctx, payload) {
  // 	ctx.commit("SET_IS_TREASURER", payload);
  // },
  // setTreasurerAccounts(ctx, payload) {
  // 	ctx.commit("SET_TREASURER_ACCOUNTS", filterTreasurerAccounts(payload.accountPermissions, ctx.state));
  // },
  // removeRedirectUrl(ctx, payload) {
  // 	ctx.commit("REMOVE_REDIRECT_URL");
  // },
};

function filterTreasurerAccounts(accounts, state) {
  return accounts
    .filter((account) => account.permissionLevel === permissionLevels.treasurer)
    .map((account) => account.accountId);
}

function filterConsultantFundraiserAccounts(accounts) {
  return accounts
    .filter(
      (account) =>
        account.permissionLevel === permissionLevels.consultant ||
        account.permissionLevel === permissionLevels.fundraiser
    )
    .map((account) => account.accountId);
}

function resetState(ctx) {
  console.log("reset state");
  ctx.commit("REMOVE_USER");
  ctx.commit("REMOVE_USER_EMAIL");
  ctx.commit("REMOVE_USER_DATE_OF_BIRTH");
  ctx.commit("REMOVE_AUTHENTICATED");
  ctx.commit("REMOVE_TOKEN");
  ctx.commit("REMOVE_TOKEN_EXPIRATION");
  ctx.commit("REMOVE_IS_SUPER_ADMIN");
  ctx.commit("REMOVE_IS_TREASURER");
  ctx.commit("REMOVE_IS_LOGIN_FROM_OLD_UI");
  ctx.commit("REMOVE_TREASURER_ACCOUNTS");
  ctx.commit("REMOVE_CONSULTANT_FUNDRAISER_ACCOUNTS");
  ctx.commit("accounts/REMOVE_ACCOUNTS", null, { root: true });
  // ctx.dispatch("app/setLoggedOut", true, { root: true });
  ctx.dispatch("blob/removeToken", true, { root: true });
}
